"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getDaysAndHoursToDueDate = function getDaysAndHoursToDueDate(hoursLeft) {
  var minus = hoursLeft < 0 ? '-' : '';
  var days = Math.floor(Math.abs(hoursLeft / 24));
  var hours = Math.abs(hoursLeft % 24);
  return "".concat(minus).concat(days, "d ").concat(hours, "h");
};

var _default = (0, _memoizeOne.default)(getDaysAndHoursToDueDate);

exports.default = _default;